import { createTrackingReportSlice } from "./components/TrackingReportView/state";

export default createTrackingReportSlice("dealsTrackingReport");
